import React, { Component } from 'react'

export default class AdvanceSearch extends Component {
  render() {
    return (
      <div>AdvanceSearch</div>
    )
  }
}
